//
// TextField.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../../lib";
import "../PromptSpecialization";
import "../../../dataDefinition/DataItem";
import "../../../common/constraints/AbstractConstraintType";

var TextField = createModule("BIRD::TextField", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel","BIRD::PromptSpecialization"], EventDispatcher, [
    ,
    {
        valueVariable: 1,
        measureVariable: 1,
        constraint: 1,
        defaultFormat: 7,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default TextField;
